import colors from './colors';

const baseButton = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '260px',
  overflow: 'hidden',
  position: 'relative',
  padding: '16px 32px',
  cursor: 'pointer',
  color: colors.white,
  background: colors.primary,
  fontSize: '18px',
  fontWeight: 700,
  appearance: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  borderRadius: '9999px',
  outline: 'none',
  userSelect: 'none',
  transition: 'all 0.3s ease',
  ':hover': {
    filter: 'brightness(1.1)',
    transform: 'translateY(-1px)',
    boxShadow: '0 10px 25px -5px rgba(0, 38, 69, 0.3)',
  },
  ':active': {
    transform: 'scale(0.95)',
  },
};

export default {
  primary: {
    ...baseButton,
  },
  disabled: {
    ...baseButton,
    opacity: 0.5,
    cursor: 'wait',
    ':hover': {
      filter: 'none',
      transform: 'none',
      boxShadow: 'none',
    },
    ':active': {
      transform: 'none',
    },
  },
  navigation: {
    ...baseButton,
    width: '100%',
    background: 'none',
    padding: '10px 0',
    fontWeight: 400,
    color: colors.primary,
    borderRadius: 0,
    ':hover': {
      filter: 'none',
      transform: 'none',
      boxShadow: 'none',
    },
  },
};
